module.exports = __webpack_public_path__ + "static/media/md-reorder.8a05dea1.svg";